import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import logo from "../../../Assets/Images/logo.png";
import axios from "axios";
import {MAIN_URL } from "../../../Configurations/Urls";

function ResetPassword({
  title = "Reset Password",
  appName = "HR ERP",
  description,
}) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const navigate = useNavigate();

  const location = useLocation();
  const email = location.state?.email;

  useEffect(() => {
    if (!email) {
      toast.error("Invalid access. Please verify OTP again.");
      navigate("/forgot-password");
    }
  }, [email]);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!newPassword || newPassword?.length < 6) {
      formErrors.newPassword = "Password must be at least 6 characters.";
      isValid = false;
    }

    if (newPassword !== confirmNewPassword) {
      formErrors.confirmNewPassword = "Passwords do not match.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleReset = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const res = await axios.post(`${MAIN_URL}/api/auth/reset-password`, {
        email,
        new_password: newPassword,
      });
  
      toast.success(res.data.message || "Password reset successful!");
      navigate("/login");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to reset password."
      );
    }

  };

  return (
    <div className="ems-auth-root">

      <div className="ems-auth-left">
        <div className="ems-auth-card">

          <div className="ems-auth-brand">
            <img src={logo} alt="HR ERP" className="ems-auth-brand-logo" />
          </div>

          <h1 className="ems-auth-h">{title}</h1>
          <p className="ems-auth-sub">Choose a new password for your account.</p>

          <form onSubmit={handleReset} noValidate>
            <div className="ems-auth-field">
              <label htmlFor="reset-pw">New Password</label>
              <input
                id="reset-pw"
                placeholder="Enter new password"
                type="text"
                value={newPassword}
                onChange={(e) => { setNewPassword(e.target.value); setErrors((p) => ({ ...p, newPassword: "" })); }}
                className="ems-fm-input"
              />
              {errors.newPassword && <span className="ems-fm-err">{errors.newPassword}</span>}
            </div>
            <div className="ems-auth-field">
              <label htmlFor="reset-pw-confirm">Confirm Password</label>
              <input
                id="reset-pw-confirm"
                placeholder="Confirm new password"
                type="password"
                value={confirmNewPassword}
                onChange={(e) => { setConfirmNewPassword(e.target.value); setErrors((p) => ({ ...p, confirmNewPassword: "" })); }}
                className="ems-fm-input"
              />
              {errors.confirmNewPassword && <span className="ems-fm-err">{errors.confirmNewPassword}</span>}
            </div>
            <div className="ems-auth-actions">
              <button type="submit" className="ems-btn ems-primary">
                Reset Password
              </button>
              <button
                type="button"
                className="ems-btn"
                onClick={() => navigate("/login")}
              >
                Back to Login
              </button>
            </div>
          </form>

        </div>
      </div>

      <div className="ems-auth-right">
        <div className="ems-auth-hero">
          <div className="ems-auth-hero-mark">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
              <path d="M5 8h16M5 13h10M5 18h16" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
          </div>
          <h2 className="ems-auth-hero-h">{appName}</h2>
          <p className="ems-auth-hero-p">
            {description ||
              "A powerful and flexible solution to manage your system efficiently. From user access to real-time reporting, everything is centralized and streamlined for a better experience."}
          </p>
          <div className="ems-auth-trust">
            <span className="ems-auth-trust-dot" />
            Trusted by thousands of users to manage their workflows.
          </div>
        </div>
        <p className="ems-auth-copy">&copy; {new Date().getFullYear()} {appName}. All rights reserved.</p>
      </div>

    </div>
  );
}

export default ResetPassword;
